import clsx from 'clsx';
import { number, shape, string } from 'prop-types';
import { useMemo } from 'react';

import { isLink } from 'helpers';
import { appService } from 'services';

const StrapiImg = ({ image = null, className = '', mobileImage = null }) => {
  const getUrl = (url) => (isLink(url) ? url : `${appService.getStrapiBaseUrl()}${url}`);

  const imageSrc = useMemo(() => {
    if (image?.frontUrl) return image.frontUrl;
    if (image?.url) return getUrl(image.url);
    return null;
  }, [image]);

  const imageMobileSrc = useMemo(() => {
    if (mobileImage?.frontUrl) return mobileImage.frontUrl;
    if (mobileImage?.url) return getUrl(mobileImage.url);
    return null;
  }, [mobileImage]);

  return (
    <>
      {imageMobileSrc && (
        <img
          src={imageMobileSrc}
          alt={imageMobileSrc?.alternativeText ?? ''}
          width={imageMobileSrc?.width ?? '80'}
          height={imageMobileSrc?.height ?? '80'}
          className={clsx(mobileImage && 'lg:hidden', className || 'w-full h-full object-cover')}
        />
      )}

      {imageSrc && (
        <img
          src={imageSrc}
          alt={image?.alternativeText ?? ''}
          width={image?.width ?? '80'}
          height={image?.height ?? '80'}
          className={clsx(mobileImage && 'hidden lg:block', className || 'w-full h-full object-cover')}
        />
      )}
    </>
  );
};

StrapiImg.propTypes = {
  image: shape({
    url: string,
    alternativeText: string,
    width: number,
    height: number
  }),
  mobileImage: shape({
    url: string,
    alternativeText: string,
    width: number,
    height: number
  }),
  className: string
};

export default StrapiImg;
